import * as sentry from '../../src/utils/sentry'
import type { Hive } from '../../src/modules/hive'
import { setReportEvent } from '../../src/redux/actions/activity'
import { Acti_SET_ACTION_TYPES, Acti_SET_ACTIVITY, Acti_SET_STORE } from './Acti.constants'
import { Acti_dispatch } from './Acti.dispatch'
import { Logg_event } from '../Logg/Logg.event'
import { Rpts_openReportFetch } from '../Rpts/Rpts.OpenReport'

export async function Acti_initialise(hive: Hive) {
    try {
        Logg_event('Start', { label: 'activity.initialise' })

        const openReport = await Rpts_openReportFetch()
        if (openReport == null) return

        hive.dispatch(setReportEvent(openReport.calendarEvent))
        Acti_dispatch({ actionType: Acti_SET_STORE, data: openReport.location })
        Acti_dispatch({ actionType: Acti_SET_ACTIVITY, data: openReport.workflow })
        Acti_dispatch({ actionType: Acti_SET_ACTION_TYPES, data: openReport.actionTypes })
    } catch (error) {
        sentry.err(error, {})
    }
}
